import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { cardHover } from 'src/theme/customEffects'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    
    card: {
      marginBottom: theme.spacing(2),
      '&.hover': cardHover(theme),
    },

    content: {},

    /* ********************************************** */
    gridRoot: {
      display: 'grid',
      //gap: theme.spacing(4),

      gridTemplateAreas: `
        "img inf"
      `,

      gridTemplateColumns: '150px auto',
    },
    /* ********************************************** */

    gridInfos: {
      display: 'grid',
      //gap: theme.spacing(4),

      gridTemplateAreas: `
        "tit"
        "pri"
        "des"
        "qty"
        "spr"
        "dlt"
        "btn"
      `,

      [theme.breakpoints.up(700)]: {
        gridTemplateAreas: `
          "tit pri"
          "des pri"
          "qty pri"
          "spr pri"
          "dlt pri"
          "btn btn"
        `,
        gridTemplateColumns: 'minmax(0, 1fr) minmax(220px, max-content)',
        gridTemplateRows: 'auto auto auto auto min-content',
      },
    },

    /* ********************************************** */

    image: {
      gridArea: 'img',
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginRight: theme.spacing(2),
      position: 'relative',
      cursor: 'pointer',
      width: 140,
      '& > img': {
        padding: 5,
        maxHeight: 190,
        objectFit: 'contain',
      }
    },

    titel: {
      gridArea: 'tit',
      marginBottom: theme.spacing(1),
      cursor: 'pointer',
      '& > a': {
        color: 'inherit',
        textDecoration: 'inherit',
      }
    },

    description: {
      gridArea: 'des',
      marginBottom: theme.spacing(1),
      '& > ul': {
        padding: 0,
        '& > li': {
          display: 'block',
          padding: 0,
        },
      },
    },

    qty: {
      gridArea: 'qty',
      marginBottom: theme.spacing(1),
    },

    singlePrice: {
      gridArea: 'spr',
      marginBottom: theme.spacing(1),
      textAlign: 'left',
      '& > div > span': {
        marginRight: theme.spacing(1),
      },
    },

    singlePriceDiscountInfo: {
      marginTop: theme.spacing(.5),
      maxWidth: 420,
    },

    deliverytime: {
      gridArea: 'dlt',
      marginBottom: theme.spacing(1),
    },

    price: {
      gridArea: 'pri',
      display: 'grid',
      justifyItems: 'end',
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      whiteSpace: 'nowrap',
    },

    countdown: {
      marginTop: theme.spacing(2),
    },

    quantityDiscountInfo: {
      justifySelf: 'end',
      marginTop: theme.spacing(.75),
      maxWidth: 260,
      minWidth: 220,
      textAlign: 'right',
      whiteSpace: 'normal',
      [theme.breakpoints.down(700)]: {
        justifySelf: 'stretch',
        maxWidth: '100%',
        minWidth: 0,
        textAlign: 'left',
      },
    },

    buttons: {
      gridArea: 'btn',
      marginTop: theme.spacing(1),
      display: 'grid',
      gap: theme.spacing(1),

      gridTemplateColumns: '1fr',
      '& > div:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },

      [theme.breakpoints.up(465)]: {
        gridTemplateColumns: 'repeat(2, max-content)',
        '& > div:not(:last-child)': {
          marginBottom: theme.spacing(0),
        },
      },

      '& > div > button': {
        marginRight: theme.spacing(1),
      },
    },

  })
)

export default useStyles
